export function ResolveCustomerMatchesCtrl (
  $scope,
  Customer,
  customer,
  inheritorApi,
  matches
) {
  $scope.customer = new Customer(customer);
  $scope.matches  = matches;

  inheritorApi.inheritCtrl('ResolveCustomerMatchesLiteCtrl', $scope);
}
